import { createFileRoute } from "@tanstack/react-router";
import { TriggerRenderForm } from "@/features/admin/components/TriggerRenderForm";
import { sftpBreadcrumbTrail } from "@/features/admin/constants/sftpNav";
import { useNav } from "@/utils/nav";

export const Route = createFileRoute("/_app/developer/sftp/upload")({
    component: SftpUploadPage,
});

function SftpUploadPage() {
    useNav(sftpBreadcrumbTrail("Upload"));

    return (
        <div className="space-y-6 mx-auto max-w-3xl">
            <div>
                <h2 className="font-semibold text-lg">Upload</h2>
                <p className="mt-1 text-muted-foreground text-sm">
                    Trigger the renderer for a single diary. Rendered PDF and JSON land in that organisation&apos;s SFTP
                    folder for NHS to pull.
                </p>
            </div>

            <TriggerRenderForm />
        </div>
    );
}
